import React from "react"
import Head from "next/head"
import { MetaKey, MetaProps } from "."
import { useRouter } from "next/router"
import { DomainPath } from "../../utils/context"

// -----------------------------
// Opengraph Docs — https://ogp.me/
// Facebook Opengraph for Video: https://developers.facebook.com/docs/sharing/webmasters#video

export const Canonical = (props: MetaProps) => {
  const { url } = props

  const router = useRouter()
  const pageUrl = !url ? `${DomainPath()}${router.asPath}` : url

  return (
    <Head>
      <link data-testid={MetaKey.Canonical} rel={MetaKey.Canonical} href={pageUrl} />
    </Head>
  )
}
